import styled from 'styled-components';
import { Field } from 'formik';
import { applyStyleModifiers } from 'styled-components-modifiers';

import { rem } from '../../../core';

const modifiers = {
  success: ({ theme }) => ({
    styles: `
      border-color: ${theme.status.success};
    `,
  }),
  danger: ({ theme }) => ({
    styles: `
      border-color: ${theme.status.danger};
    `,
  }),
};

export const InputWrapper = styled.div.attrs({
  className: 'InputWrapper',
})`
  position: relative;
  display: flex;
  flex-flow: column-reverse;

  label, input {
    transition: all 0.2s;
    touch-action: manipulation;
  }

  input:placeholder-shown + label {
    cursor: text;
    max-width: 10rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transform-origin: left bottom;
    transform: translate(1rem, -0.4rem) scale(1);
  }

  input:not(:placeholder-shown) + label,
  input:focus + label {
    transform: translate(1.0625rem, -1rem) scale(1);
    cursor: pointer;
    font-size: 0.7rem;
  }
`;

export const LabelInput = styled.label.attrs({
  className: 'LabelInput',
})`
  font-size: 1rem;
  color: #909090;
  pointer-events: none;
  transition: all 0.25s ease;
  text-align: left;
  position: absolute;
  top: 50%;
  transform: translate(1rem, 0) scale(1);
`;

export const InputStyled = styled(Field)`
  font-family: ${(props) => props.theme.fontFamily};
  width: 100%;
  height: 48px;
  padding: 1.125rem 1rem 0.5rem;
  border: 1px solid #D4DADC;
  border-radius: ${rem(0)};
  outline: none;
  ::placeholder {
    color: ${(props) => props.theme.content.placeholder};
    opacity: 0;
    transition: inherit;
  }

  &:focus::-webkit-input-placeholder {
    opacity: 1;
  }

  &:disabled {
    background-color: #F2F2F2;
    color: #8E9DA2;
    border: solid 1px #E6E6E6;
    pointer-events: none;
  }

  ${applyStyleModifiers(modifiers)};
`;
